
import { useAddUserToAccount } from '@api/accounts';
import { Modal, Button, Stack, TextInput, Switch } from '@mantine/core';
import { useForm } from '@mantine/form';
import { emailValidator } from '@pages/authenticated/documents/form/formValidators';

function AddUserModal({ opened, close }: { opened: boolean, close: () => void }) {
  const { mutate: addUser } = useAddUserToAccount()
  const form = useForm({
    initialValues: { email: '', admin: false },
    validate: {
      email: (value) => {
        if (!value) {
          return 'Debes ingresar un correo';
        }
        return emailValidator(value, false);
      },
    },
  });
  return (
    <Modal.Root size="md" opened={opened} onClose={close} centered>
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header>
          <Modal.Title fz={20} fw={600}>
            Añadir usuario a la cuenta
          </Modal.Title>
          <Modal.CloseButton />
        </Modal.Header>
        <Modal.Body>
          <form
            onSubmit={form.onSubmit((values, event) => {
              event?.preventDefault();
              event?.stopPropagation();
              addUser({ data: values });
              form.reset();
              close();
            })}
          >
            <Stack align="center">
              <TextInput
                label="email"
                placeholder="Correo"
                required
                value={form.values.email}
                error={form.errors.email}
                {...form.getInputProps('email')}
              />
              <Switch
                labelPosition="left"
                onLabel="SÍ" offLabel="NO"
                label="Este usuario es administrador?"
                checked={form.values.admin}
                onChange={(event) => form.setFieldValue('admin', event.currentTarget.checked)}
                size="md"
              />
              <Button type="submit">Añadir</Button>
            </Stack>
          </form>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  )
}

export default AddUserModal;